
/* eslint-disable class-methods-use-this */
import Component from 'vue-class-component';
import Vue from 'vue';

const TEST_ID = 'KLoans-SummaryCard';

@Component
export default class SummaryCard extends Vue {
	public TEST_ID = TEST_ID;
}

